import { z } from 'zod';

export const TFileSchema = z.object({
  name: z.string(),
  type: z.string(),
  size: z.number(),
  base64: z.string(),
});

export type TFile = z.infer<typeof TFileSchema>;
